import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Box, Button, Typography, Paper } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

export default function Forbidden() {
  const { instance, accounts } = useMsal();
  const email = accounts[0]?.username ?? '';

  const handleSignOut = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: '/login' });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Paper elevation={3} sx={{ p: 6, textAlign: 'center', maxWidth: 420 }}>
        <BlockIcon sx={{ fontSize: 56, color: 'error.main', mb: 2 }} />
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={1}>
          Your account does not have permission to access this system.
        </Typography>
        {email && (
          <Typography variant="body2" color="text.secondary" mb={3}>
            Signed in as: <strong>{email}</strong>
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary" mb={4}>
          Please contact your administrator to request access.
        </Typography>
        <Button variant="outlined" fullWidth onClick={handleSignOut}>
          Sign out
        </Button>
      </Paper>
    </Box>
  );
}
